import { parseApiError } from '../apiError';

/**
 * What the two password-reset pages (/recover with a key, /reset-password with an emailed
 * code) say when a reset is turned down. (#928)
 *
 * They used to read the error with `err.response.body.text()`. Amplify v6 hands the body over
 * as text already, so that never yielded anything, and every failure showed the page's one
 * message: a weak password read as a wrong recovery key or an expired code.
 *
 * - The password policy is the one server message shown as sent: it is written for users and
 *   says what to change.
 * - Any other 400 is the page's own message: the key or code did not match. That is the only
 *   other refusal these routes send.
 * - Anything else says to try again: a failure on our side, a busy route (POST /recover is
 *   throttled for everyone at once), a dropped connection, or a refusal from in front of the
 *   API. None of those is the key's or code's fault. A gateway's own text ("Internal server
 *   error") is never shown.
 */
export const RESET_FAILED = 'We could not reset your password. Please try again.';

export async function resetErrorMessage(err: unknown, rejected: string): Promise<string> {
  const e = await parseApiError(err);
  if (e.code === 'INVALID_PASSWORD') return e.message;
  return e.status === 400 ? rejected : RESET_FAILED;
}
